import { Notification } from "../../../resources";

const fetchNotifications = (onSuccess, onError) => {
  Notification.all()
    .then((notificationsCollectionResponse) => {
      onSuccess(notificationsCollectionResponse);
    })
    .catch((err) => {
      onError(err);
    });
};

export default fetchNotifications;
